

var tml = gsap.timeline({ defaults: { duration: 1 } })
tml.fromTo("body", { opacity: 0, backgroundColor: 'black' }, { opacity: 1, ease: "Power1.easeInOut", delay: 1 },)
    .fromTo(".nav_component", { opacity: 0, y: -100 }, { opacity: 1, y: 0, stagger: 0.1, ease: "Power1.easeInOut" }, "-=0.2")
    .fromTo(".nav_logo", { rotate: 0 }, { rotate: 360, ease: "Power1.easeInOut" }, "-=0.6")
    .fromTo(".header_wrapper", { opacity: 0, x: 50 }, { opacity: 1, ease: "Power1.easeInOut", x: 0 }, "-=0.8")
    .fromTo(".header_lottie-component", { opacity: 1, y: 1500, }, { opacity: 1, ease: "Power1.easeInOut", y: 0 },)
    .fromTo(".sup", { color: 'white', }, { color: '#F95A5A', ease: "Power2.easeInOut", y: 0, stagger: 0.01 },)

// .to(".sup", { "clip-path": "polygon(100% 0%, 0% 0%, 0% 125%, 100% 100%)",
// x: 0,
// duration: 1.8,})


let laptl = gsap.timeline({ defaults: { duration: 1 } })

laptl.fromTo(".course-wyn_animation-text-left", { x: 60, }, { x: 0, ease: "Power1.easeInOut", }, "-=0.10")
    .fromTo(".course-wyn_animation-text-right", { x: -60, }, { x: 0, ease: "Power1.easeInOut", }, "-=0.9")
    .fromTo(".course-wyn_midi-image", { opacity: 0, }, { opacity: 1, ease: "Power1.easeInOut", }, "-=0.9")
// .fromTo(".course-wyn_midi-title-mobile", { opacity:0,y:50, }, { opacity:1,y:0, ease: "Power1.easeInOut", }, "-=0.9")

ScrollTrigger.create({
    trigger: '.course-wyn_animation-text-left',
    start: "top 50%",
    end: "+=500",
    animation: laptl,
    // scrub: true, //enterback
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
});


let laptlm = gsap.timeline({ defaults: { duration: 1 } })

laptlm.fromTo(".course-wyn_midi-title-mobile", { opacity: 0, y: 300, }, { opacity: 1, y: 0, ease: "Power1.easeInOut", }, "")

ScrollTrigger.create({
    trigger: '.sup',
    start: "top 10%",
    end: "+=500",
    animation: laptlm,
    // scrub: true, //enterback
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
});



let crstl = gsap.timeline({ defaults: { duration: 1 } })

crstl.fromTo(".course-modules_heading-wrapper", { opacity: 0, y: 100, }, { opacity: 1, y: 0, ease: "Power1.easeInOut", }, "")
    .fromTo(".course-modules_subheading", { opacity: 0, y: 70, }, { opacity: 1, y: 0, ease: "Power1.easeInOut", }, "-=0.5")
    .fromTo("#stylebtn", { opacity: 0, y: 50, }, { opacity: 1, y: 0, ease: "Power1.easeInOut", }, "-=0.5")


ScrollTrigger.create({
    trigger: '#abtbtn',
    start: "top 10%",
    end: "+=500",
    animation: crstl,
    // scrub: true, //enterback
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
});


let syctl = gsap.timeline({ defaults: { duration: 1 } })

syctl.fromTo(".webdev_syl", { opacity: 1, x: 270, }, { zIndex: 10, opacity: 1, x: 0, ease: "Power1.easeInOut", }, "")
    .fromTo(".webdev_lott", { opacity: 1, x: -270, }, { zIndex: 9, opacity: 1, x: 0, ease: "Power1.easeInOut", }, "")



ScrollTrigger.create({
    trigger: '#stylebtn',
    start: "top 60%",
    end: "+=500",
    animation: syctl,
    scrub: true, //enterback
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
    toggleActions: "play pause resume reset"
});


let autsyctl = gsap.timeline({ defaults: { duration: 1 } })

autsyctl.fromTo(".idaut_syl", { opacity: 1, x: -270, }, { zIndex: 10, opacity: 1, x: 0, ease: "Power1.easeInOut", }, "")
    .fromTo(".idaut_lott", { opacity: 1, x: 270, }, { zIndex: 9, opacity: 1, x: 0, ease: "Power1.easeInOut", }, "")


ScrollTrigger.create({
    trigger: '.webdev_lott',
    start: "100% 50%",
    end: "+=500",
    animation: autsyctl,
    scrub: true, //enterback
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
    toggleActions: "play pause resume reset"
});

let embsyctl = gsap.timeline({ defaults: { duration: 1 } })

embsyctl.fromTo(".embdev_syl", { opacity: 1, x: 270, }, { zIndex: 10, opacity: 1, x: 0, ease: "Power1.easeInOut", }, "")
    .fromTo(".embdev_lott", { opacity: 1, x: -270, }, { zIndex: 9, opacity: 1, x: 0, ease: "Power1.easeInOut", }, "")
   


ScrollTrigger.create({
    trigger: '.idaut_syl',
    start: "bottom 50%",
    end: "+=500",
    animation: embsyctl,
    scrub: true, //enterback    
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
    toggleActions: "play pause resume reset"
});





let ulktl = gsap.timeline({ defaults: { duration: 1 } })

ulktl.fromTo(".course-areas_content-wrapper", { opacity: 0, y: 270, scale: 5 }, { opacity: 1, scale: 1, y: 0, ease: "Power1.easeInOut", }, "")

ScrollTrigger.create({
    trigger: '#dwnbtn',
    start: "top 50%",
    end: "+=500",
    animation: ulktl,
    // scrub: true, //enterback
    // events: onEnter onLeave onEnterBack onLeaveBack
    // toggleActions: "restart play reverse reset"
    // toggleActions: "play pause resume reset"
});


let movtxtl = gsap.timeline({ defaults: { duration: 2 } })

movtxtl.to(".to-right", { x: -1500, ease: "power1.inOut", }, "")
    .to(".to-left", { x: 1500, ease: "power1.inOut",}, "")

ScrollTrigger.create({
    trigger: '.course-areas_content-wrapper',
    start: "top 70%",
    end: "+=" + (window.innerHeight * 10),
    anticipatePin: true,
    animation: movtxtl,
    scrub: true, //enterback
    // markers: true,
    // events: onEnter onLeave onEnterBack onLeaveBack
    toggleActions: "play pause resume reset"
});


  // Dropdowns
  $('.dd_label').click(function () {
    $(this).closest('.dropdown').toggleClass('active')
      .siblings('.dropdown')
      .removeClass('active'); 
    // if other dropdowns are open, hide them.
      });
  
  // If you click outside of the dropdown, hide the dropdown.
  $(document).mouseup(function(e){
          var dropDownLabel =   $('.dd_label');
          if (!dropDownLabel.is(e.target) // The target of the click isn't the dropdown.
          && dropDownLabel.has(e.target).length === 0) // Nor a child element of the dropdown
          {
              $('.dd_label').closest('.dropdown').removeClass('active');
          }
      });